import { createI18n } from '@drama/i18n'
import { en } from './en.js'
import { zh } from './zh.js'
import { ja } from './ja.js'
import { es } from './es.js'
import { id } from './id.js'
import { pt } from './pt.js'

export const adminMessages = { en, zh, ja, es, id, pt }

/**
 * @param {{ locale: string }} opts
 */
export function createAdminI18n(opts) {
  const locale = Object.hasOwn(adminMessages, opts.locale) || opts.locale === 'ko' ? opts.locale : 'zh'
  const runtime = createI18n({ locale: locale === 'id' ? 'en' : locale })
  const i18n = runtime.i18n
  for (const [language, messages] of Object.entries(adminMessages)) i18n.global.mergeLocaleMessage(language, messages)
  let requested = locale
  const ready = runtime.ready.then(() => { if (requested === locale) i18n.global.locale.value = locale })
  return {
    i18n,
    ready,
    getLocale: () => i18n.global.locale.value,
    async setLocale(nextLocale) {
      if (!Object.hasOwn(adminMessages, nextLocale) && nextLocale !== 'ko') {
        throw new Error(`Unsupported locale: ${nextLocale}`)
      }
      requested = nextLocale
      await ready
      if (nextLocale === 'id') {
        await runtime.loadLocale('en')
        if (requested === nextLocale) i18n.global.locale.value = nextLocale
      } else {
        await runtime.loadLocale(nextLocale)
        if (requested === nextLocale) i18n.global.locale.value = nextLocale
      }
    },
  }
}
